








































import { InstrumentStatus } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InstrumentName from "./InstrumentName.vue";
import * as RouteNames from "@/employee/route-names";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

const maxTableRows = 10;

@Component({
  components: {
    GenericLoadingSpinner,
    InstrumentName,
  }
})
export default class OpenBrokerageSearch extends Vue {
  searchTerm: string = null;

  @Prop({ required: false }) username: string;

  @Prop({ required: false }) partnerId: number;

  @Prop({ required: false }) accountId: number;

  drivewealthStore = useDrivewealthStore();

  statusMap = drivewealth.statusMap;

  mounted () {
    this.searchTerm = this.drivewealthStore.instrumentSearchTerm;
  }

  @Watch("searchTerm")
  onSearchTermChange (searchValue): void {
    this.debouncedSearch(searchValue, this.accountId);
  }

  debouncedSearch = _.debounce(
      (s, a) => this.drivewealthStore.searchInstruments({ searchTermParam: s, accountId: a }), 600);

  get noSearchResults () {
    return !!this.searchTerm && this.drivewealthStore.instrumentSearchIsLoaded &&
        this.drivewealthStore.instrumentSearchResults.length === 0;
  }

  get showBusyState () {
    return this.drivewealthStore.instrumentSearchIsLoading || this.noSearchResults;
  }

  get detailItems () {
    if (!this.drivewealthStore.instrumentSearchResults) {
      return [];
    }

    return this.drivewealthStore.instrumentSearchResults.slice(0, maxTableRows).map(d => ({
      instrument: { symbol: d.stockSymbol, companyName: d.companyName, website: d.website, imageUrl: d.imageUrl },
      status: this.statusMap[d.status],
      action: { symbol: d.stockSymbol },
    }));
  }

  detailFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Instrument"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center"
    },
  ];

  routeParams (symbol: string): { symbol: string, accountId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId };
    }

    return { symbol };
  }

  get buyRoute (): string {
    if (this.accountId) {
      return RouteNames.DrivewealthBuyInstrumentV2;
    }

    return RouteNames.DrivewealthBuyInstrument;
  }


  canBuy (instrumentStatus: string) {
    return !this.username && instrumentStatus === this.statusMap[InstrumentStatus.Active];
  }
}
